import { useTranslation } from "react-i18next";
import { SectionCard } from "../../components/SectionCard/SectionCard.js";
import { SectionCardHeader } from "../../components/SectionCard/SectionCardHeader.js";
import { SectionCardHStack } from "../../components/SectionCard/SectionCardHStack.js";
import { SectionCardGrid } from "../../components/SectionCard/SectionCardGrid.js";
import { SectionCardVStack } from "../../components/SectionCard/SectionCardVStack.js";

export function ForestOwnerSection() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-24">
            <SectionCard
                id="forest-owner-relations"
                img="cards/summer-cropped.png"
                className="bg-green"
                gradientClassName="green-gradient"
            >
                <SectionCardHeader
                    title={t("home-forest-owner-relations-card-title")}
                    text={t("home-forest-owner-relations-card-text")}
                />
                <SectionCardGrid className="grid-cols-3">
                    <SectionCardHStack
                        className="col-span-3"
                        img="cards/man-cropped.png"
                        title={t(
                            "home-forest-owner-relations-card-section-1-title",
                        )}
                        text={t(
                            "home-forest-owner-relations-card-section-1-text",
                        )}
                    />
                    <SectionCardVStack
                        title={t(
                            "home-forest-owner-relations-card-section-2-title",
                        )}
                        text={t(
                            "home-forest-owner-relations-card-section-2-text",
                        )}
                    />
                    <SectionCardVStack
                        title={t(
                            "home-forest-owner-relations-card-section-3-title",
                        )}
                        text={t(
                            "home-forest-owner-relations-card-section-3-text",
                        )}
                    />
                    <SectionCardVStack
                        title={t(
                            "home-forest-owner-relations-card-section-4-title",
                        )}
                        text={t(
                            "home-forest-owner-relations-card-section-4-text",
                        )}
                    />
                </SectionCardGrid>
            </SectionCard>
        </div>
    );
}
